import React from 'react';

const GoalIcon = ({ fill, className }) => {
  return (
    <svg
      width='19'
      height='18'
      viewBox='0 0 19 18'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      className={className}
    >
      <path
        fill-rule='evenodd'
        clip-rule='evenodd'
        d='M9.1125 11.5539L18.7375 2.15781C19.0875 1.81613 19.0875 1.30362 18.7375 0.961945C18.3875 0.62027 17.8625 0.62027 17.5125 0.961945L8.5 9.76007L6.4875 7.79544C6.1375 7.45377 5.6125 7.45377 5.2625 7.79544C4.9125 8.13712 4.9125 8.64963 5.2625 8.9913L7.8875 11.5539C8.0625 11.7247 8.2375 11.8101 8.5 11.8101C8.7625 11.8101 8.9375 11.7247 9.1125 11.5539ZM15.3 9.28638C15.3 8.77154 15.64 8.42832 16.15 8.42832C16.66 8.42832 17 8.77154 17 9.28638V15.2929C17 16.7516 15.895 17.8671 14.45 17.8671H2.55C1.105 17.8671 0 16.7516 0 15.2929V3.2799C0 1.82118 1.105 0.705688 2.55 0.705688H11.9C12.41 0.705688 12.75 1.04892 12.75 1.56376C12.75 2.0786 12.41 2.42183 11.9 2.42183H2.55C2.04 2.42183 1.7 2.76506 1.7 3.2799V15.2929C1.7 15.8077 2.04 16.1509 2.55 16.1509H14.45C14.96 16.1509 15.3 15.8077 15.3 15.2929V9.28638Z'
        fill={fill}
      />
    </svg>
  );
};

export default GoalIcon;
